import { Droplets, Gem, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";

const ITEMS = [
  {
    icon: Droplets,
    title: "Extrait de parfum 30 %",
    text: "Une concentration élevée : quelques pressions suffisent, la tenue est exceptionnelle.",
  },
  {
    icon: Gem,
    title: "Le luxe du sillage",
    text: "De grandes fragrances à prix accessible — sans compromis sur la qualité.",
  },
  {
    icon: MessageCircle,
    title: "Conseils personnalisés",
    text: "Votre consultante Vāsam vous accompagne pour trouver votre signature olfactive.",
  },
];

export const Arguments = () => (
  <section className="border-b border-espresso/10 bg-cream py-16 sm:py-20">
    <div className="wrap grid gap-10 sm:grid-cols-3">
      {ITEMS.map((item, i) => (
        <Reveal key={item.title} delay={i * 0.1}>
          <div className="flex items-start gap-5">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-champagne/40 text-champagne">
              <item.icon size={17} strokeWidth={1.5} />
            </span>
            <div>
              <h3 className="font-serif text-2xl leading-tight text-espresso">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-espresso/65">{item.text}</p>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
